/* ============================================
   输入框处理 Mixin
   ============================================
   包含输入框的 focus/blur/input 处理逻辑
   用于减少代码重复，便于维护
   ============================================ */

import { validateEmail } from './utils.js';

export default {
  data() {
    return {
      isFocused: false
    };
  },
  methods: {
    /**
     * 处理输入框 focus 事件
     * @param {string} errorEventName - 清除错误的事件名称（如 'clear-error'）
     */
    onFocus(errorEventName = 'clear-error') {
      this.isFocused = true;
      if (errorEventName) {
        this.$emit(errorEventName);
      }
    },
    
    /**
     * 处理输入框 blur 事件
     */
    onBlur() {
      this.isFocused = false;
    },
    
    /**
     * 处理输入框 input 事件（通用方法）
     * @param {Event} event - 输入事件
     * @param {string} updateEventName - 更新值的事件名称（如 'update:email'）
     * @param {string} errorEventName - 清除错误的事件名称（如 'clear-error'）
     */
    handleInputGeneric(event, updateEventName, errorEventName = 'clear-error') {
      const value = event.target.value.replace(/\s/g, '');
      event.target.value = value;
      if (updateEventName) {
        this.$emit(updateEventName, value);
      }
      if (errorEventName) {
        this.$emit(errorEventName);
      }
    }
  },
  computed: {
    /**
     * 验证邮箱（通用计算属性）
     * 子组件可以通过 props 传入 email 值来使用
     */
    isValidEmailComputed() {
      return (email) => {
        return validateEmail(email || '');
      };
    },
    
    /**
     * 判断是否应该显示浮动标签（在边框上方）
     * @param {string} value - 输入框的值
     * @param {boolean} hasError - 是否有错误
     * @returns {boolean} 是否显示标签
     */
    shouldShowLabel() {
      return (value, hasError = false) => {
        return !!(hasError || value || this.isFocused);
      };
    },
    
    /**
     * 判断是否应该显示占位符（在输入框内部）
     * @param {string} value - 输入框的值
     * @param {boolean} hasError - 是否有错误
     * @returns {boolean} 是否显示占位符
     */
    shouldShowPlaceholder() {
      return (value, hasError = false) => {
        return !(value || hasError || this.isFocused);
      };
    }
  }
};

